/**
 * @file company.js
 * @description 인사말 페이지에서 복사한 문구와 관리자 입력 메타데이터입니다.
 * @used-in content/registry/index.js
 */

// [비즈니스] 기본값은 CompanyGreetingsPage.jsx의 현재 문구를 그대로 유지합니다.
// [기술] type은 편집 위젯용이며 공개 렌더 방식에는 영향을 주지 않습니다.
export const COMPANY_CONTENT = {
  'company.ceo.letter.eyebrow': {
    type: 'text',
    label: '상단 영문 라벨',
    defaultText: 'CEO Message',
  },
  'company.ceo.letter.headingLine1': {
    type: 'text',
    label: '제목 첫째 줄',
    defaultText: '고객의 제조 현장에',
  },
  'company.ceo.letter.headingLine2': {
    type: 'text',
    label: '제목 둘째 줄',
    defaultText: '꼭 필요한 가치를 만들겠습니다.',
  },
  'company.ceo.letter.lead': {
    // [비즈니스] longtext는 넓은 입력칸을 뜻하며 편집 문구의 개행은 허용하지 않습니다.
    type: 'longtext',
    label: '인사말 도입 문장',
    defaultText: '새힘정보기술 홈페이지를 찾아주셔서 진심으로 감사드립니다.',
  },
  'company.ceo.letter.paragraphs': {
    type: 'list',
    label: '인사말 본문 문단',
    itemLabel: '문단',
    // [비즈니스] 문단은 관리자가 추가·삭제·순서 변경을 할 수 있는 가변 목록입니다.
    //            기본값은 배선 이전의 일곱 문단 원문 그대로입니다.
    defaultItems: [
      '새힘정보기술은 우리가 가장 잘할 수 있는 일, 그리고 고객에게 실질적인 도움이 되는 일을 찾는 고민에서 시작했습니다. 그 답은 제약, 화장품, 식품 등 GMP 제조현장의 체계적인 관리를 돕는 통합 솔루션이었습니다.',
      '그동안 저희는 다양한 제조기업들과 함께하며 GMP 현장의 변화와 성장을 가까이에서 경험해왔습니다. 강화되는 규정과 빠르게 달라지는 시장 환경 속에서도 국민의 건강과 아름다움을 위해 묵묵히 제조 현장을 지켜가는 고객들을 보며, 저희 역시 더 큰 책임감과 사명감을 갖게 되었습니다.',
      '제조 현장의 디지털 전환은 단순히 시스템을 도입하는 일에 그치지 않습니다. 원료의 입고부터 칭량, 생산, 품질, 출하와 창고 관리에 이르기까지 현장의 흐름을 정확히 이해하고, 데이터가 끊김 없이 이어지며, 누구나 신뢰할 수 있는 기준으로 운영될 때 비로소 의미 있는 변화가 시작됩니다.',
      '새힘정보기술은 이러한 변화의 과정에서 고객의 업무를 깊이 이해하고, 현장에서 실제로 사용할 수 있는 솔루션을 만드는 데 집중해왔습니다. 규정 준수와 추적성, 업무 효율과 운영 안정성을 함께 고려하여 고객의 제조 환경에 맞는 더 나은 방식을 제안하겠습니다.',
      '또한 구축 이후의 운영과 유지보수까지 책임 있게 함께하는 파트너가 되고자 합니다. 작은 개선 요청 하나에도 현장의 불편함이 담겨 있다는 마음으로 귀 기울이고, 고객의 성장 속도에 맞춰 솔루션도 함께 발전시키겠습니다.',
      '새힘정보기술은 이제 새로운 도약을 준비하고 있습니다. 그동안 축적해온 기술력과 현장 경험을 바탕으로 어제의 성과에 머무르지 않고, 끊임없이 변화하고 도전하는 기업이 되겠습니다.',
      '앞으로도 새힘정보기술만의 진정성과 전문성을 잃지 않고, 고객의 제조 현장에 꼭 필요한 가치 있는 솔루션을 제공하겠습니다. 항상 새롭게 성장하는 모습으로 보답하겠습니다.',
    ],
  },
  'company.ceo.letter.signature': {
    type: 'text',
    label: '서명',
    defaultText: '새힘정보기술 한종호',
  },
};
